import { ActionTypes } from "@/actions";

function firstSelectOptionStoredValue(field: any): string {
    const raw = field?.options ?? field?.value;
    let options: string[] = [];
    if (!raw) {
        options = [];
    } else if (Array.isArray(raw)) {
        options = raw.map((o: unknown) => String(o).trim()).filter(Boolean);
    } else if (typeof raw === "string") {
        options = raw.split(",").map((s: string) => s.trim()).filter(Boolean);
    }
    if (options.length === 0) return "";
    const first = options[0]!;
    return first.includes(":") ? first.split(":")[0]!.trim() : first;
}

const initialState: any = {
    current: {},
    isNew: false,
    currentSlug: undefined,
    currentCollection: undefined,
}

const itemReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case ActionTypes.EDIT_ITEM_START: {
            const nextSlug = action.payload?.slug || state.currentSlug;
            const nextCollection = action.payload?.collection || state.currentCollection || action.payload?.slug;
            return {
                ...state,
                isNew: false,
                current: action.payload.data,
                currentSlug: nextSlug,
                currentCollection: nextCollection
            };
        }
        case ActionTypes.EDIT_ITEM_UPDATED: {
            const key = action.payload.key;
            const value = action.payload.value;
            const prev = state.current;
            const next: Record<string, unknown> = {
                ...prev,
                [key]: value,
            };
            const labelKey = `${key}__label`;
            const labelsKey = `${key}__labels`;
            if (Object.prototype.hasOwnProperty.call(prev, labelKey)) {
                next[labelKey] = '';
            }
            if (Object.prototype.hasOwnProperty.call(prev, labelsKey)) {
                next[labelsKey] = [];
            }
            return {
                ...state,
                isNew: state.isNew,
                current: next,
            };
        }
        case ActionTypes.EDIT_ITEM_NEW:
            const initialOverrides = action.payload.initial;
            const newItemUid = typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
                ? crypto.randomUUID()
                : `new-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
            let emptyItem: any = {
                _created: new Date(),
                uid: newItemUid
            };
            const fields = action.payload.fields;
            if (fields && typeof (fields) !== 'undefined' && fields.length > 0) {
                action.payload.fields?.map((field: any) => {
                    if (field.type === 'boolean' || field.type === 'checkbox') {
                        if (field.value === true) {
                            emptyItem[field.name] = true
                        } else if (field.value === false) {
                            emptyItem[field.name] = false
                        } else {
                            emptyItem[field.name] = field.value.length > 0 ? true : false
                        }
                    } else if (field.type === 'number') {
                        if (field.value === undefined || field.value === null || field.value === '') {
                            emptyItem[field.name] = 0
                        } else if (!isNaN(Number(field.value))) {
                            emptyItem[field.name] = Number(field.value)
                        } else {
                            emptyItem[field.name] = field.value
                        }
                    } else if (field.type === 'select' || field.type === 'dropdown') {
                        if (field.allowEmptyOption === false) {
                            const fallback = firstSelectOptionStoredValue(field);
                            const d = field.defaultOption;
                            emptyItem[field.name] =
                                d !== undefined && d !== null && d !== ''
                                    ? d
                                    : fallback;
                        } else {
                            emptyItem[field.name] = field.defaultOption ?? ''
                        }
                    } else if (field.type === 'code') {
                        emptyItem[field.name] = ''
                    } else {
                        emptyItem[field.name] = field.value
                    }
                })
            }

            const initial = {

                ...emptyItem,
                ...initialOverrides
            }

            const newItemCollection = action.payload.collection || action.payload.slug || state.currentCollection;

            return {
                ...state,
                isNew: true,
                current: initial,
                currentSlug: action.payload.slug,
                currentCollection: newItemCollection,
            }
        case ActionTypes.STORE_UPDATED_SUCCESS:
            return {
                ...state,
                isNew: false,
                current: action.payload,
            }
        case ActionTypes.QUICK_ADD_UPDATE_SUCCESS:
            return {
                ...state,
                current: action.payload,
            }
        case ActionTypes.EDIT_ITEM_RESET_CURRENT:
            return {
                ...state,
                current: action.payload || {},
            }


        default:
            return state;
    }
}

export default itemReducer;